<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Sticky Block End Point -->
      <!-- <div id="stickyBlockEndPoint"></div> -->
      <div class="container space-top-3 space-bottom-2" style="max-width:800px">
          <div class="w-lg-100 mx-lg-left">
            <div class="mb-4">
              <h1 class="h2" style="font-weight:600">{{articleDetail.title}}</h1>
            </div>
          </div>
          <!-- Author -->
          <div class="border-top  py-4 mb-2">
            <div class="row align-items-md-center">
              <div class="col-md-7 mb-5 mb-md-0">
                <div class="media align-items-center">
                  <span class="d-block text-muted">内容更新：{{getTime( articleDetail.releaseTime? articleDetail.releaseTime :  articleDetail.updateTime)}}</span> 
                </div>
              </div>
            </div>
          </div>
          <!-- End Author -->
          <p class="border-bottom pb-4 img-width" v-html="articleDetail.content"></p>
          <el-tag v-for="(item,index) in tagList" :key="index" style="margin-right:8px;color:#21335b;margin-bottom:8px" type="info" >{{item}}</el-tag>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js";
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js";

import "@/assets/vendor/font-awesome/css/all.min.css";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css";
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.css";
import "@/assets/vendor/aos/dist/aos.css";
import "@/assets/css/theme.css";
import "@/assets/vendor/hs-header/dist/hs-header.min.js";
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js";
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js";
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.js";
import "@/assets/vendor/appear.js";
import "@/assets/vendor/circles/circles.min.js";
import "@/assets/vendor/polifills.js";
import AOS from "aos";
// import 'aos/dist/aos.css'

// import 'bootstrap'
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/js/hs.core.js";
import "@/assets/js/hs.fancybox.js";

import "@/assets/js/hs.circles.js";
import "@/assets/vendor/hs-counter/dist/hs-counter.min.js";
import Header from "../components/header";
import Footer from "../components/footer";
import moment from 'moment'
import { getcontent, getsyres ,getcaseDetail} from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },

  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
  data(){
    return{
      articleDetail:{},
      tagList:[]
    }
  },
  created(){
    if(this.$route.query.id){
      this.getDetail(this.$route.query.id)
    }
  },
  methods:{
    //获取案例详情
    getDetail(id){
      getcontent(id).then(res=>{
        this.articleDetail = res.data.content[0]
        this.tagList = this.articleDetail.fromuser.split(/-|，|,|;|；|：|:/)
      })
    },
    // 时间转换
    getTime(val){
        return moment(val).get('year') + " 年 " + (parseInt(moment(val).get('month')) + 1) + " 月 " + moment(val).get('date') + " 日"
    }
  }
};
</script>

<style scoped>
.bg-img-hero {
  background: url("../assets/svg/components/abstract-shapes-5.svg") center;
}
.pb-5,
.py-5 {
  padding: 2rem 0 !important;
}
.text-dark {
  line-height: 1.6;
  color: #1e2022 !important;
}
.text-body {
  color: #677788 !important;
}
.mb-3 h4 {
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
.col-sm-12 h4 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.4;
}
.col-sm-12 p {
  font-size: 0.875rem;
  color: #677788 !important;
}
#stickyBlockStartPoint {
  position: sticky !important;
  position: -webkit-sticky;
  top: 10px;
}
.pl-lg-4 .h3 {
  margin-bottom: 0.5rem;
  font-size: 1.3125rem;
  font-weight: 600;
  line-height: 1.4;
}
.pl-lg-4 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.font-weight-normal {
  font-size: 1.875rem;
  line-height: 1.4;
  
}
.mx-lg-auto .mb-0 {
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.text-muted {
  font-weight: 400;
  color: #8c98a4 !important;
  line-height: 1.6;
}
a {
  text-decoration: none;
}
.mb-md-9 h2 {
  font-size: 1.875rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.card-body .mb-0 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.6;
}
.card-body .mb-01 {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.6;
}
.mx-lg-auto .mb-00 {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}

</style>


// WEBPACK FOOTER //
// src/view/detail.vue